/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CreateLimitMarginOrderMutationVariables = Types.Exact<{
	request: Types.CreateLimitMarginOrderRequest;
}>;

export type CreateLimitMarginOrderMutation = {
	__typename?: "Mutation";
	createLimitMarginOrder:
		| { __typename?: "CreateLimitMarginOrderPendingResponse"; amountAsset: string }
		| {
				__typename?: "CreateLimitMarginOrderSuccessResponse";
				orderId: string;
				tradeFiatId: string;
				amountAsset: string;
				amountFiat: string;
				createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		  };
};

export const CreateLimitMarginOrderDocument = gql`
	mutation createLimitMarginOrder($request: CreateLimitMarginOrderRequest!) {
		createLimitMarginOrder(request: $request) {
			... on CreateLimitMarginOrderSuccessResponse {
				orderId
				tradeFiatId
				amountAsset
				amountFiat
				createdAt {
					iso8601
					unixTimestamp
				}
			}
			... on CreateLimitMarginOrderPendingResponse {
				amountAsset
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CreateLimitMarginOrderGQLService extends Apollo.Mutation<
	CreateLimitMarginOrderMutation,
	CreateLimitMarginOrderMutationVariables
> {
	document = CreateLimitMarginOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
